export const OFFERS_HOME = "/offers";
export const OFFER_DETAIL = `${OFFERS_HOME}/:offerId`;
export const EXEC_HOME = `${OFFERS_HOME}/exec`;

export const linkTo = {
  offers: () => OFFERS_HOME,
  offerDetail: id => OFFER_DETAIL.replace(":offerId", id),
};
